import { combineReducers } from "redux";
import auth from './auth';
import city from './city';
import tab_permission from './tab_permission'

export default combineReducers({
  auth,
  city,
  tab_permission
})